export default {
    recipes: [],
    totalDataRow:0 
}
  